import { useState } from 'react'

import { Dialog, DialogContent, DialogTitle } from 'components/ui/dialog'

import { useUnreadNotifications } from '../hooks/useUnreadNotifications'
import { BellButton } from './BellButton'
import { NotificationList } from './NotificationList'

/**
 * The bell in the field app's header (MYD-542), beside Messages. A dialog
 * rather than a popover: on a phone a popover anchored to a 44px button is a
 * cramped corner, and the field profile already opens the same way.
 */
export function FieldNotificationButton() {
	const unreadCount = useUnreadNotifications()
	const [open, setOpen] = useState(false)
	const close = () => setOpen(false)

	return (
		<>
			{/* 44px and round, matching the field header's Messages button. */}
			<BellButton unreadCount={unreadCount} open={open} aria-expanded={open} onClick={() => setOpen(true)} className="w-11 h-11 rounded-full" />
			{open && (
				<Dialog open onClose={close}>
					<DialogContent hideClose className="max-w-md p-0">
						<DialogTitle className="sr-only">Notifications</DialogTitle>
						<NotificationList className="max-h-[75svh]" onNavigate={close} onClose={close} />
					</DialogContent>
				</Dialog>
			)}
		</>
	)
}

export default FieldNotificationButton
